"use client";

import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  Suspense,
} from "react";
import { useSearchParams, useRouter } from "next/navigation";
import { Center, Spinner } from "@chakra-ui/react";

type SearchContextType = {
  searchName: string;
  setSearchName: (name: string) => void;

  searchCategory: string;
  setSearchCategory: (category: string) => void;

  searchTrigger: boolean;
  setSearchTrigger: (trigger: boolean) => void;

  searchResults: any[]; // FIXED
  setSearchResults: (results: any[]) => void; // FIXED
};

const SearchContext = createContext<SearchContextType | undefined>(undefined);

const SearchContextContent: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [searchName, setSearchName] = useState("");
  const [searchCategory, setSearchCategory] = useState("");
  const [searchTrigger, setSearchTrigger] = useState(false);

  const [searchResults, setSearchResults] = useState<any[]>([]);

  const searchParams = useSearchParams();
  const router = useRouter();

  useEffect(() => {
    const keywordFromURL = searchParams.get("keyword") || "";
    const categoryFromURL = searchParams.get("category") || "";

    if (keywordFromURL) setSearchName(keywordFromURL);
    if (categoryFromURL) setSearchCategory(categoryFromURL);

    if (keywordFromURL || categoryFromURL) {
      setSearchTrigger(true);
    }
  }, []);

  useEffect(() => {
    if (searchTrigger) {
      const params = new URLSearchParams();

      if (searchName) params.set("keyword", searchName);
      if (searchCategory) params.set("category", searchCategory);

      router.replace(`/?${params.toString()}`);
    }
  }, [searchTrigger, searchName, searchCategory]);

  return (
    <SearchContext.Provider
      value={{
        searchName,
        setSearchName,
        searchCategory,
        setSearchCategory,
        searchTrigger,
        setSearchTrigger,
        searchResults,
        setSearchResults,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  const context = useContext(SearchContext);
  if (!context) {
    throw new Error("useSearch must be used within a SearchProvider");
  }
  return context;
};

export const SearchProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  return (
    <Suspense
      fallback={
        <Center h="100vh">
          <Spinner size="xl" color="blue.500" />
        </Center>
      }
    >
      <SearchContextContent>{children}</SearchContextContent>
    </Suspense>
  );
};
